/** 1スライドあたりの SP/PC 画像の生URL（最適化は OptimizedImage が行う） */
export interface ResponsiveImageSlide {
  /** SP 用 生 URL */
  sp: string;
  /** PC 用 生 URL */
  pc: string;
}

/**
 * SP/PC 画像配列を index で対にした生URLのスライド配列に変換する。
 *
 * - 片方が欠ける index はもう片方で補完する（SP/PC どちらか一方しか無くても表示できる）
 * - SP/PC とも空なら fallbackImages（共通画像）で補完する
 * - 最適化(format=auto/リサイズ)は描画側の OptimizedImage が行うため、ここでは生URLのみ扱う
 *
 * MainVisual（ヒーロー）・記事メディアなど SP/PC 出し分けの picture を組む箇所で共通利用する。
 */
export const buildResponsiveImageSlides = (pcImages?: string[], spImages?: string[], fallbackImages: string[] = []): ResponsiveImageSlide[] => {
  const pc = pcImages?.length ? pcImages : fallbackImages;
  const sp = spImages?.length ? spImages : fallbackImages;
  const length = Math.max(pc.length, sp.length);
  return Array.from({ length }, (_, i) => ({
    pc: pc[i] ?? sp[i],
    sp: sp[i] ?? pc[i],
  }));
};
